<template>
  <div id="impact">
      <AppNavigation bgColor="white" textColor="rgb(255,128,57)" from='impact'/>

      <!----------------- HERO IMAGE ---------->
      <div id="hero">
         
      </div>

      <!--------------------- Impact page text ------------->
      <div id="main" class="d-flex flex-wrap align-content-center justify-content-center">
        <div class="container-fluid">
          <div class="row align-content-center m-0 p-0" >
            <div class="col-5 side-image-left-container">
              <img class="side-image-left img-fluid" src="../assets/images/circle_orange.png" alt="" >
            </div>
            <div class="col-12 hero-text justify-content-center align-items-center">
              <div class="row justify-content-center">
                  <div class="padding" >
                    <h2 class="text-center py-3">
                        IMPACT
                    </h2>
                   <ul>
                       <li>
                          <i> <img src="../assets/images/list_icon.jpg" alt=""> </i> Loans will strengthen value chains identified within selected areas to keep business within chain active.
                       </li>
                       <li>
                          <i> <img src="../assets/images/list_icon.jpg" alt=""> </i> Grant will provide a lifeline for micro entreprises to get back on track and be profitable during and after 
                           COVID-19 era.
                       </li>
                       <li>
                           <i> <img src="../assets/images/list_icon.jpg" alt="">  </i> The overall impact is to contribute massively to the recovery of the general economic situation
                           of the country while securing its socio-economic well-being where we think globally with a 
                           localised approach.
                       </li>
                   </ul>
              </div>
              </div>
            </div>
            <div class="col-3 side-image-right-container">
              <img  class="side-image-right img-fluid" src="../assets/images/circle_orange.png" alt="" >
            </div>
          </div>
        </div>
      </div>
      <!------------------ FOOTER ------------------->
      <Footer />

  </div>
</template>

<script>
import Footer from '../components/Footer'
import AppNavigation from '../components/AppNavigation'
export default {
    components: {
        AppNavigation,
        Footer
    }
}
</script>

<style scoped>
    #impact{
        width:100%;
        overflow:hidden;
    }
    #hero{
        background-image: url('../assets/images/impact_main_hero.jpg');
        width:100%;
        height:100vh;
        overflow: hidden;
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;    
        }
    #main{
        position: relative;
    }
     .side-image-left-container{
        position:absolute;
        left:-22%;
        }
    .side-image-right-container{
        position:absolute;
        right:-15%;
        bottom: 0;
        }   
    .hero-text h2{
        color:black;
        font-weight: 700;
        font-size: 4em;
        }
    .hero-text button{
        margin:1.5em;
        padding:10px;
        }
    .padding{
      padding:150px 20%;
    }
    ul li{
        color:rgb(255,128,57);
        line-height: 2em ;
        list-style: none;
    }
    ul li i img{
        height:25px;
        padding-right:8px;
    }
    /* ul li i{
        background-image: url('../assets/images/list_icon.jpg');
    } */
    @media screen  and (max-width:600px){
     .padding{
      padding:100px 5% !important;
    }   
    }
</style>